import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardRlt2Props {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCardRlt2 = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardRlt2Props) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-18231" data-mp="325rehj851lt2">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-18232" data-mp="374ukp6zuty2m">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-18233" data-mp="3c24fl260j1xu">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-18234" data-mp="3gtvycqixg3df">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-18235" data-mp="3lticr3ahrpnt" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-18236" data-mp="3puu5viskqt0r">
          <span className="font-medium text-gray-800" data-id="element-18237" data-mp="3pw58hfaa9uqa">{name}</span>
          <span className="mx-1" data-id="element-18238" data-mp="3utnht6s7qbyt">•</span>
          <span data-id="element-18239" data-mp="3uugibq0kw58i">{location}</span>
          <span className="mx-1" data-id="element-18240" data-mp="3urkj7yczvaih">•</span>
          <span data-id="element-18241" data-mp="sw176rxx291n">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-18242" data-mp="ou7a0tmxjn68">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-18243" data-mp="jw5v8kwjea0k" />
          <span data-id="element-18244" data-mp="evzxqo3l5tak">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCardRlt2;